import { MEDIA } from "../../constants/media";
import { Briefcase, Building2, CalendarPlus, MapPinned } from "lucide-react";

export const Stats = ({ stats }) => {
  if (!stats) return null;
  const items = [
    { icon: Briefcase, value: stats.active_jobs, label: "Vagas ativas agora" },
    { icon: CalendarPlus, value: stats.new_this_week, label: "Novas esta semana" },
    { icon: Building2, value: stats.companies, label: "Empresas aprovadas" },
    { icon: MapPinned, value: 308, label: "Concelhos cobertos" },
  ];
  return (
    <section className="relative overflow-hidden" data-testid="stats-section">
      <img src={MEDIA.portoRibeira} alt="Porto, Portugal — vista aérea da Ribeira e rio Douro" loading="lazy"
        className="absolute inset-0 w-full h-full object-cover opacity-10" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#FAFAFA] via-transparent to-[#FAFAFA]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 py-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((s) => (
            <div key={s.label}
              className="bg-white/90 backdrop-blur-sm rounded-2xl border border-black/5 p-6 hover:shadow-md hover:-translate-y-0.5 transition-all">
              <s.icon className="w-5 h-5 text-amber-500 mb-3" strokeWidth={1.75} />
              <p className="font-heading font-black tracking-tighter text-4xl text-slate-900">
                {s.value >= 1000 ? `${(s.value / 1000).toFixed(1)}k` : s.value}
              </p>
              <p className="text-xs uppercase tracking-[0.14em] font-bold text-slate-500 mt-1">{s.label}</p>
            </div>
          ))}
        </div>
        <p className="text-[11px] text-slate-400 mt-3 text-center">
          Números reais da plataforma, atualizados a cada visita — nunca inventamos métricas.
        </p>
      </div>
    </section>
  );
};
